// extracted by mini-css-extract-plugin
module.exports = {"page":"MainPage_page_2lum8","appear":"MainPage_appear_3xLRz","appear-to":"MainPage_appear-to_27xjs","appear-active":"MainPage_appear-active_33w5l"};